module.exports = __webpack_public_path__ + "static/10-5d48fcd71746bbd099947c3d2ad8a8bf.jpg";